import React from "react";
import { NavLink, Link } from "react-router-dom";

export default class POrt extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <img src="http://nb.isbelle.com.cn/templets/2018/wap/images/index/tel.jpg" />
    );
  }
}
